import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function WhyDietsFailSection() {
  const reasons = ['Las ensaladas frías no satisfacen el paladar latino y te dejan con hambre a las 3 PM.', 'Los productos "Light" están llenos de azúcar escondida bajo nombres químicos que no conoces.', 'Intentas dejar el dulce por "fuerza de voluntad", pero tu biología está programada para pedir azúcar cuando tienes estrés.', 'Te sientes obligada a comer "comida de hospital" sin sabor, lo cual te hace abandonar al tercer día.'];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-181">
      <FadeIn data-id="element-182">
        <div className="text-center mb-12" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-brown mb-4" data-id="element-184">
            POR QUÉ LAS DIETAS TRADICIONALES EN USA NO TE FUNCIONAN:
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-185"></div>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-186">
        {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-187">
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-cinnamon/10 flex items-start space-x-4 h-full" data-id="element-188">
              <XCircle className="w-8 h-8 text-terracotta flex-shrink-0 mt-1" data-id="element-189" />
              <p className="text-lg text-dark-brown/80 leading-relaxed" data-id="element-190">
                {reason}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}